import { PermissionObject } from '@eadsysteme/ewsauthclient-v1';

export class PermissionTypeStringToEnumUtil {
	public static getPermissionTypeByName(permissionTypeName: string): PermissionObject.PermissionTypeEnum {
		switch (permissionTypeName) {
			case 'OWNER':
				return PermissionObject.PermissionTypeEnum.OWNER;
			case 'RESIDENT':
				return PermissionObject.PermissionTypeEnum.RESIDENT;
			// Fehlte bis DEV-23651: eine Mieter-Berechtigung ging dadurch mit leerem Typ zum Auth-Service.
			case 'TENANT':
				return PermissionObject.PermissionTypeEnum.TENANT;
			case 'PROPERTY_MANAGEMENT':
				return PermissionObject.PermissionTypeEnum.PROPERTY_MANAGEMENT;
			case 'SERVICE_PROVIDER':
				return PermissionObject.PermissionTypeEnum.SERVICE_PROVIDER;
			default:
				return undefined;
		}
	}
}
